export default __webpack_public_path__ + "static/media/15_2.5c4dfa29.jpg";